/**
 * gm-wholesale.js
 * Sistema de precios mayoristas para Accesorios GM Mayoreo
 * Activa modo mayoreo cuando el subtotal original del carrito >= $2,500 MXN
 * Solo aplica a productos elegibles (sin tags: nomayoreo, maquillaje, empaques, seguro)
 */

(function() {
  'use strict';

  const WHOLESALE_THRESHOLD = 250000; // $2,500 en centavos
  const LS_KEY = 'gm_wholesale_active';

  function formatMoney(cents) {
    const intCents = Math.round(cents);
    const pesos = Math.floor(intCents / 100);
    const centavos = intCents % 100;
    const centStr = centavos < 10 ? '0' + centavos : '' + centavos;
    return '$' + pesos.toLocaleString('es-MX') + '.' + centStr + ' MXN';
  }

  function wholesalePrice(priceCents) {
    return Math.round(priceCents * 70 / 100);
  }

  let wholesaleActive = false;

  function setWholesaleState(active) {
    if (wholesaleActive === active) return;
    wholesaleActive = active;
    try {
      if (active) {
        localStorage.setItem(LS_KEY, '1');
        document.documentElement.classList.add('gm-wholesale-active');
      } else {
        localStorage.removeItem(LS_KEY);
        document.documentElement.classList.remove('gm-wholesale-active');
      }
    } catch(e) {}
    updateAllPrices();
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(r => r.json())
      .catch(() => null);
  }

  function checkCartAndUpdate() {
    fetchCart().then(cart => {
      if (!cart) return;
      const subtotal = cart.original_total_price || 0;
      setWholesaleState(subtotal >= WHOLESALE_THRESHOLD);
      updateAnnouncementBarWithCart(cart);
    });
  }

  function updateAllPrices() {
    const containers = document.querySelectorAll('[data-gm-price-container]');
    containers.forEach(container => {
      // Respetar si el producto es elegible para mayoreo
      const eligible = container.getAttribute('data-gm-eligible') !== 'false';
      if (!eligible) return; // productos de ofertas/maquillaje: nunca cambiar

      const priceCents = parseInt(container.getAttribute('data-gm-price-cents') || '0', 10);
      const regularEl = container.querySelector('.gm-price-regular');
      const wholesaleEl = container.querySelector('.gm-price-wholesale');
      if (!regularEl || !wholesaleEl) return;

      if (wholesaleActive) {
        regularEl.style.display = 'none';
        wholesaleEl.style.display = '';
        const wPrice = wholesaleEl.querySelector('.gm-price-wholesale-value');
        if (wPrice) wPrice.textContent = formatMoney(wholesalePrice(priceCents));
      } else {
        regularEl.style.display = '';
        wholesaleEl.style.display = 'none';
      }
    });
  }

  function updateAnnouncementBarWithCart(cart) {
    const bar = document.querySelector('[data-gm-announcement]');
    if (!bar) return;
    const subtotal = cart ? (cart.original_total_price || 0) : 0;

    if (subtotal >= WHOLESALE_THRESHOLD) {
      bar.innerHTML = '🎉✨ ¡PRECIO MAYOREO ACTIVADO! · 30% DE DESCUENTO EN TU PEDIDO ✨🎉';
      bar.classList.add('gm-announcement__inner--active');
      bar.style.background = '';
    } else {
      const faltante = WHOLESALE_THRESHOLD - subtotal;
      bar.innerHTML = '🛍️ AGREGA ' + formatMoney(faltante) + ' MÁS Y ACTIVA TU 30% DE MAYOREO 🛍️';
      bar.classList.remove('gm-announcement__inner--active');
      bar.style.background = '';
    }
  }

  document.addEventListener('cart:refresh', checkCartAndUpdate);
  document.addEventListener('cart:updated', checkCartAndUpdate);
  document.addEventListener('shopify:section:load', checkCartAndUpdate);

  const _fetch = window.fetch;
  window.fetch = function(resource, options) {
    const p = _fetch.apply(this, arguments);
    if (typeof resource === 'string' && (
      resource.includes('/cart/add') ||
      resource.includes('/cart/change') ||
      resource.includes('/cart/update') ||
      resource.includes('/cart/clear')
    )) {
      p.then(() => setTimeout(checkCartAndUpdate, 300));
    }
    return p;
  };

  document.addEventListener('change', function(e) {
    if (!wholesaleActive) return;
    const form = e.target.closest('form[data-type="add-to-cart-form"], form.product-form');
    if (!form) return;
    setTimeout(updateAllPrices, 150);
  });

  function init() {
    try {
      if (localStorage.getItem(LS_KEY) === '1') {
        document.documentElement.classList.add('gm-wholesale-active');
        wholesaleActive = true;
      }
    } catch(e) {}
    checkCartAndUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
